export const isValidUrl = (url: string): boolean => /^(https?:\/\/)?([\w-]+\.)+[\w-]+(\/[\w-./?%&=#]*)*\/?(\?[a-zA-Z0-9-_]+=[a-zA-Z0-9-%]+(&[a-zA-Z0-9-_]+=[a-zA-Z0-9-%]+)*)?(#\w+)?$/.test(url)
